const INITIAL_STATE = {
  phone_number: "",
  user_car_id: null,
  user_car_name: "",
  user_car_year: null,
  odometer_value: null,
  order_lines: [],
  is_coupon: null,
  skip_step: null,
  qr_order_lines: [],
  qr_token: null,
  qr_lat: null,
  qr_lng: null,
  qr_bill_id: null,
};

const serviceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_PHONE_NUMBER":
      return { ...state, phone_number: action.phone_number };
    case "SET_is_coupon":
      return { ...state, is_coupon: action.is_coupon };
    case "SET_ODOMETER_VALUE":
      return { ...state, odometer_value: action.odometer_value };
    case "SET_ORDER_LINES":
      return { ...state, order_lines: action.order_lines };
    case "SET_USER_CAR":
      return {
        ...state,
        user_car_id: action.user_car_id,
        user_car_name: action.user_car_name,
        user_car_year: action.user_car_year,
        user_car_brand_name: action.user_car_brand_name,
      };
    case "SET_SKIP_STEP":
      return { ...state, skip_step: action.skip_step };
    case "SET_QR_ORDER_LINES":
      return { ...state, qr_order_lines: action.qr_order_lines };
    case "SET_QR_META":
      return { ...state, ...action.qrMeta };
    case "RESET_QR_SERVICE_STATE":
      return {
        ...state,
        skip_step: null,
        qr_order_lines: [],
        qr_token: null,
        qr_lat: null,
        qr_lng: null,
        qr_bill_id: null,
      };
    case "RESET_SERVICE_STATE":
      return INITIAL_STATE;
    default:
      return state;
  }
};
export default serviceReducer;